import * as React from 'react';
import { HeroImageContainer, HeroImageSrc } from './index.style';
import { mediaQueries } from '../../../utils';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const HeroImage = () => {
  const { ASSET_PREFIX } = publicRuntimeConfig;
  return (
    <HeroImageContainer>
      <source srcSet={`${ASSET_PREFIX}images/Hero-desktop@2x.jpg`} media={mediaQueries.desktop2x} />
      <source srcSet={`${ASSET_PREFIX}images/Hero-desktop.jpg`} media={mediaQueries.desktop1x} />
      <source srcSet={`${ASSET_PREFIX}images/Hero-tablet@2x.jpg`} media={mediaQueries.tablet2x} />
      <source srcSet={`${ASSET_PREFIX}images/Hero-tablet.jpg`} media={mediaQueries.tablet1x} />
      <source srcSet={`${ASSET_PREFIX}images/Hero-mobile@2x.jpg`} media={mediaQueries.mobile2x} />
      <source srcSet={`${ASSET_PREFIX}images/Hero-mobile.jpg`} media={mediaQueries.mobile1x} />
      <HeroImageSrc src={`${ASSET_PREFIX}images/Hero-mobile.jpg`} alt="Lounge room with couch and plants" />
    </HeroImageContainer>
  );
};
